export const getNavUrl = (option: any) =>
  option.withoutDashboard && option.key === 'home'
    ? '/dashboard'
    : `/dashboard/${option.key}`;

export const isNavActive = (pathname: string, key: string) => {
  if (key === 'home') {
    return pathname === '/dashboard' || pathname === '/dashboard/';
  }
  return pathname.includes(`/dashboard/${key}`);
};

export const isNavParentActive = (pathname: string, option: any) => {
  if (option.children) {
    return option.children.some((child: any) =>
      isNavActive(pathname, child.key)
    );
  }
  return isNavActive(pathname, option.key);
};
